import React from 'react';
import { cn } from '../cn';
import { Typography } from '../Typography/Typography';
import { LabelAria } from '@react-aria/label';

export type LabelProps = {
  /**
   * Indicates that the Textfield is required.
   */
  required?: boolean,
  /**
   * Applies additional class names to the element.
   */
  className?: string,
  /**
   * Props from react-aria.
   */
  labelProps: LabelAria['labelProps'],
  /**
   * String used as the Textfield's label.
   */
  children: React.ReactNode,
}

export default function TextfieldLabel({ required = false, className, labelProps, children }: LabelProps): JSX.Element {
  return (
    <label {...labelProps}>
      <Typography size='sm' weight='bold' tag='p' color='text-light' className={cn([
        className,
      ])}>
        {children}
        {required && (<span className='pl-0.5 text-text'>*</span>)}
      </Typography>
    </label>
  );
}
